import React from "react";
import NFEPageFilter from "../../Components/PageFilters/NFEPageFilter";
import {Grid} from "@mui/material";
// import IndicatorsCard from "./IndicatorsCard";
import NFEsList from "./NFEsList";
import Permission from "../../Components/Permission";
import SpedStatusHandler from "../Dashboard/SpedStatusHandler";

const NFEs: React.FC = () => {
    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);
    const [competenciaDataInicio, setCompetenciaDataInicio] = React.useState<string>('');
    const [competenciaDataFim, setCompetenciaDataFim] = React.useState<string>('');

    return (<>
        <Grid container spacing={0.5}>
            <SpedStatusHandler
                onSpedFiscalIdChange={(id: number | null, dataInicio?: string, dataFim?: string) => {
                    console.log('[NFEs] SpedStatusHandler onSpedFiscalIdChange', { id, dataInicio, dataFim });
                    setSpedFiscalIdSelecionado(id);
                    setCompetenciaDataInicio(dataInicio || '');
                    setCompetenciaDataFim(dataFim || '');
                }}
            />
            <NFEPageFilter 
                dataInicioCompetencia={competenciaDataInicio} 
                dataFimCompetencia={competenciaDataFim} 
            />
            {/* <IndicatorsCard/> */}
            {/* <Permission accountProducts='CREDIT_DEBIT_CARD'> */}
            <NFEsList 
                spedFiscalId={spedFiscalIdSelecionado} 
                dataInicioCompetencia={competenciaDataInicio}
                dataFimCompetencia={competenciaDataFim}
            />
            {/* </Permission> */}
        </Grid>
    </>);
}

export default NFEs;
